export default "__VITE_ASSET__CPniYpN5__"